import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import React from 'react';
import { FILL_COLOR_MAP } from '../../utils/accessibility.js';
import { Icon } from '../Icon/icon.js';

const ButtonIcon = ({
  buttonRef,
  className,
  icon,
  iconFill,
  iconName,
  isDisabled,
  onClick,
  size = "medium",
  style,
  testSection,
  title,
  ...props
}) => {
  const fillColor = iconFill && Object.keys(FILL_COLOR_MAP).includes(iconFill) ? FILL_COLOR_MAP[iconFill] : void 0;
  function handleOnClick(event) {
    if (isDisabled) {
      return;
    }
    onClick && onClick(event);
  }
  const iconSize = size === "small" ? "small" : "medium";
  return /* @__PURE__ */ jsx(
    "button",
    {
      className: classNames(
        `oui-button oui-button-icon oui-button-icon__${size} oui-button--${style}`,
        fillColor ? "" : "axiom-button-icon--no-fill",
        className
      ),
      "data-oui-component": true,
      "data-test-section": testSection,
      disabled: isDisabled,
      onClick: handleOnClick,
      ref: buttonRef,
      title,
      type: "button",
      ...props,
      children: /* @__PURE__ */ jsx("div", { className: "flex flex--dead-center ", children: /* @__PURE__ */ jsx(
        Icon,
        {
          color: fillColor,
          icon,
          name: iconName,
          size: iconSize,
          title
        }
      ) })
    }
  );
};
ButtonIcon.defaultProps = {
  iconName: "add",
  onClick: () => null,
  size: "medium",
  title: ""
};
var ButtonIcon$1 = React.memo(ButtonIcon);

export { ButtonIcon$1 as default };
